const filmLocationRouter = {
  route: null,
  name: null,
  title: '拍摄景地',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-set-up',
  filePath: 'view/shooting_site/', // 文件路径
  order: 10,
  inNav: true,
  permission: ['拍摄景地'],
  children: [
    {
      title: '添加景地',
      type: 'view',
      name: 'addShootingSite',
      route: '/shootingSite/add',
      filePath: 'view/shooting_site/create.vue',
      inNav: true,
      icon: 'iconfont el-icon-document-add',
      permission: ['添加景地'],
    },
    {
      title: '景地列表',
      type: 'view',
      name: 'shootingSiteList',
      route: '/shootingSite/list',
      filePath: 'view/shooting_site/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['景地列表'],
    },
    {
      title: '城市分类',
      type: 'view',
      name: 'cityList',
      route: '/shootingSite/citys',
      filePath: 'view/shooting_site/citys.vue',
      inNav: true,
      icon: 'iconfont el-icon-film',
      permission: ['城市分类'],
    },
    {
      title: '风格分类',
      type: 'view',
      name: 'styleList',
      route: '/shootingSite/styles',
      filePath: 'view/shooting_site/styles.vue',
      inNav: true,
      icon: 'iconfont el-icon-film',
      permission: ['城市分类'],
    },
  ],
}

export default filmLocationRouter
